import { IOfferSchema, IAgentSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

import { isAgency, isFromBuilder, isOfficialSeller } from './agent';
import { isManagementCompany } from './isManagementCompany';
import { isRentDepartment } from './isRentDepartment';

export const isAvatarAgentRoundness = (offer: IOfferSchema, agent: IAgentSchema): boolean => {
  const { isDeveloper } = agent;

  return (
    !(isAgency(agent) || agent.isSubAgent) &&
    !isManagementCompany(agent) &&
    !isRentDepartment(agent) &&
    !isDeveloper &&
    !isFromBuilder(offer) &&
    !isOfficialSeller(offer)
  );
};
